
import React from 'react';
import { motion } from 'framer-motion';

interface ViewFinderProps {
  isScanning: boolean;
}

const ViewFinder: React.FC<ViewFinderProps> = ({ isScanning }) => {
  return (
    <div className="relative">
      {/* Improved viewfinder frame with corner highlights */}
      <div className="border-2 w-72 h-72 border-blue-500 rounded-lg relative pointer-events-none overflow-hidden">
        <div className="absolute top-0 left-0 w-8 h-8 border-t-4 border-l-4 border-blue-500 rounded-tl"></div>
        <div className="absolute top-0 right-0 w-8 h-8 border-t-4 border-r-4 border-blue-500 rounded-tr"></div>
        <div className="absolute bottom-0 left-0 w-8 h-8 border-b-4 border-l-4 border-blue-500 rounded-bl"></div>
        <div className="absolute bottom-0 right-0 w-8 h-8 border-b-4 border-r-4 border-blue-500 rounded-br"></div>
        
        {/* Scanning animation line */}
        {isScanning && (
          <motion.div 
            className="absolute left-0 right-0 h-1 bg-blue-500 z-10 opacity-70"
            initial={{ top: 0 }}
            animate={{ top: '100%' }}
            transition={{ 
              duration: 2, 
              repeat: Infinity, 
              ease: "easeInOut",
              repeatType: "reverse" 
            }}
          />
        )}
        
        {/* Pulsing effect */}
        {isScanning && (
          <motion.div 
            className="absolute inset-0 border-2 border-blue-400 rounded-lg"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: [0, 0.5, 0], scale: [0.9, 1.1, 0.9] }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ViewFinder;
